import React from 'react';
import classNames from 'classnames';
import { useTheme } from '../theme/themeContext';

const Card = ({ children, className }) => {
  const { sidebarColor, isDark } = useTheme();

  // 色に応じたボーダーカラーの設定（インラインスタイル）
  const getBorderStyle = () => {
    const borderColors = {
      blue: { borderColor: '#3b82f6', borderWidth: '2px' }, // blue-500
      green: { borderColor: '#10b981', borderWidth: '2px' }, // green-500
      red: { borderColor: '#ef4444', borderWidth: '2px' }, // red-500
      purple: { borderColor: '#8b5cf6', borderWidth: '2px' } // purple-500
    };
    return borderColors[sidebarColor] || { borderColor: '#6b7280', borderWidth: '2px' }; // gray-500
  };

  const getDarkBorderStyle = () => {
    const darkBorderColors = {
      blue: { borderColor: '#1d4ed8', borderWidth: '2px' }, // blue-700
      green: { borderColor: '#047857', borderWidth: '2px' }, // green-700
      red: { borderColor: '#b91c1c', borderWidth: '2px' }, // red-700
      purple: { borderColor: '#7c3aed', borderWidth: '2px' } // purple-700
    };
    return darkBorderColors[sidebarColor] || { borderColor: '#374151', borderWidth: '2px' }; // gray-700
  };

  const borderStyle = isDark ? getDarkBorderStyle() : getBorderStyle();

  return (
    <div 
      className={classNames(
        'bg-white dark:bg-gray-800 rounded-lg border',
        className
      )}
      style={borderStyle}
    >
      {children}
    </div>
  );
};

export default Card; 